<template>
  <div class="container">

    <div class="row">

      <div class="col-6">
        <h4>فرم:
          {{ form.name }}
        </h4>
      </div>

      <div class="col-6">
        <h4>پاسخ نامه:
          {{ user.name }} {{ user.last_name }}
          <router-link target="_blank" class="p"
                       :to="{ name: 'UpdateUser', params: { id: user.id } }">
            (پروفایل)
          </router-link>
        </h4>
      </div>


    </div>

    <div class="col-12">
      <table class="table table-hover table-striped table-bordered table-responsive-md table-responsive-sm">
        <thead>
        <tr>
          <th scope="col">شناسه</th>
          <th scope="col">سوال</th>
          <th scope="col">پاسخ</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="answer in answers">
          <th>{{ answer.id }}</th>
          <td>{{ formQuestion(form, answer.form_item_id)['title'] }}</td>
          <td v-html="formAnswerManager(formAnswer(form, answer.form_item_id, answer))"></td>
        </tr>
        </tbody>
      </table>
    </div>

    <form @submit.prevent="sendFormDescription">
      <div class="form-group">
        <label for="exampleFormControlTextarea1">توضیحات</label>
        <textarea minlength="1" v-model="formFillDescription" :disabled="!isAdmin" class="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"></textarea>
      </div>

      <div class="col-12 text-center">
        <button type="submit" class="btn btn-primary px-5" v-if="isAdmin">ثبت</button>
      </div>

    </form>

    <hr>

    <div class="border shadow p-3 rounded">
      <h1>چت با کاربر</h1>

      <chat-form v-if="formFillChatSlug() == false && isAdmin" class="form-answer-chat-form" :submit-function="startNewChatWrapper"/>
      <div class="" v-if="formFillChatSlug() != false">
        <m-a :href="formFillChatSlug()" target="_blank">
          <button class="btn btn-primary rounded-pill">مشاهده چت</button>
        </m-a>
      </div>
    </div>


  </div>
</template>

<script>
import {formAnswer, formQuestion} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Form";
import {mapGetters} from "vuex";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import ChatForm from "@/plugin/components/dashboard/Chat/ChatForm.vue";

export default {
  name: "FormAnswer",
  components: {ChatForm},
  data() {
    return {
      answers: {},
      form: {},
      user: {},
      formFillMeta: {},
      formFillDescription: '',
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: "User/isAdmin",
      adminProfile: "User/getProfile"
    }),
    formFillId() {
      return this.$route.params.form_fill
    },
  },
  methods: {
    formAnswer,
    formQuestion,
    setFormFillDescription(metas) {

      metas.forEach(item => {
        if (item.name == 'form-fill-description') {
          this.formFillDescription = item.value
        }
      })

    },
    getAnswerData() {
      let form = {
        user_id: this.$route.params.user,
        form_fill_id: this.$route.params.form_fill,
      }
      let req = this.$store.dispatch('Form/getFormAnswer', form)
      req.then(res => {
        let baseData = res.data.data

        this.answers = baseData.answers
        this.form = baseData.form
        this.user = baseData.user
        this.formFillMeta = baseData.formFillMeta
        this.setFormFillDescription(this.formFillMeta)
      })
    },
    sendFormDescription() {
      let form = {
        description: this.formFillDescription,
        id: ''
      }
      form.id = this.$route.params.form_fill
      console.log(form)
      this.$store.dispatch("Form/setDescriptionOfFormFill", form)
    },
    formAnswerManager(item) {
      let value = item['label']
      if (item['type'] == 'image') {
        let src = `${findAttributeOnSiteInfo('host')}/${value}`
        return `<img style="width: 150px;object-fit: contain" src="${src}" />`
      }

      return value
    },
    storeChatLink(chatLink) {
      let form = {
        "name": 'form_fill_chat_link',
        "value": chatLink,
        "metable_type": 'formFill',
        "metable_id": this.formFillId,
        "type": 0,
        "overwrite_preview_value": 0,
      }
      this.$store.dispatch('Meta/createMeta', form).then(res => {
        this.getAnswerData()
      })
    },
    startNewChatWrapper(form) {
      let adminChatToken = this.adminProfile.chat_token
      let userChatToken = this.user.chat_token

      form.withoutState = true

      form.users = [...new Set([adminChatToken, userChatToken])]


      this.$store.dispatch('Chat/startNewChat', form).then(res => {
        let data = res.data.data.data
        let slug = data.slug

        this.storeChatLink(slug)

        let routeData = this.$router.resolve({name: 'SingleChat', params: {slug: slug}});
        window.open(routeData.href, '_blank');

      })
    },
    formFillChatSlug() {
      let result = false
      if (Object.keys(this.formFillMeta).length == 0) {
        return result
      }
      this.formFillMeta.forEach(item => {
        if (item.name == "form_fill_chat_link") {
          result = this.$router.resolve({name: 'SingleChat', params: {slug: item.value}}).href
        }
      })
      return result
    }

  },
  mounted() {
    this.getAnswerData()


  }
}
</script>


<style scoped>
.form-answer-chat-form ::v-deep .chat-form-tags,
.form-answer-chat-form ::v-deep .chat-form-users,
.form-answer-chat-form ::v-deep .chat-form-group,
.form-answer-chat-form ::v-deep .chat-form-files,
.form-answer-chat-form ::v-deep .chat-form-categories {
  display: none;
}
</style>